// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Uz1wj","location":"Header_location__3KXCC"};